import { render, staticRenderFns } from "./SlideDetail.vue?vue&type=template&id=70d71ab4"
import script from "./SlideDetail.vue?vue&type=script&lang=js"
export * from "./SlideDetail.vue?vue&type=script&lang=js"
import style0 from "./SlideDetail.vue?vue&type=style&index=0&id=70d71ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports